import React from 'react';

import { getAdvancedSettings } from '../advancedSettings';
import { getBackgroundSettings } from '../backgroundSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import classes from './PageBuilderColumn.module.scss';
import type { ColumnType } from './columnConfigAggregator';

type PageBuilderColumnProps = ColumnType;

/**
 * Return the PB Column Block
 * @param props
 * @constructor
 */
export function PageBuilderColumn(props: PageBuilderColumnProps) {
    /**
     * Configure the styles requires for the Block
     */
    const backgroundStyles = getBackgroundSettings<PageBuilderColumnProps>({ ...props });
    const advancedSettings = getAdvancedSettings<PageBuilderColumnProps>(props);

    const layoutStyles = {
        width: '100%',
        minHeight: props.minHeight,
    };

    if (props.verticalAlignment) {
        layoutStyles['display'] = 'flex';
        layoutStyles['flexDirection'] = 'column';
        layoutStyles['justifyContent'] = props.verticalAlignment;
    }

    if (props.selfAlignment) {
        layoutStyles['alignSelf'] = props.selfAlignment;
    }

    const columnClassNames = [classes['root'], 'pageBuilderColumnGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        columnClassNames.push(...props.cssClasses);
    }

    const backgroundImageStyles = `
        #${props.uniqueID} {
            background-image: url(${props.mobileImage ?? props.desktopImage})
        }
    
        @media (min-width: 900px) {
            #${props.uniqueID} {
                background-image: url(${props.desktopImage})
            }
        }
    `;

    /**
     * Render the Column Block UI
     */
    return (
        <>
            {props.desktopImage && <style dangerouslySetInnerHTML={{ __html: backgroundImageStyles }} />}
            <div className={columnClassNames.join(' ')} style={{ width: props.width }}>
                <PageBuilderElementWrapper
                    contentType={props.contentType}
                    uniqueID={props.uniqueID}
                    styles={{
                        ...backgroundStyles,
                        ...advancedSettings,
                        ...layoutStyles,
                    }}
                >
                    {props.children}
                </PageBuilderElementWrapper>
            </div>
        </>
    );
}
